module.exports = __webpack_public_path__ + "mainassets/img/faq-1.e27ef7fd.svg";